module.exports = __webpack_public_path__ + "img/calendar-6.708fc8a3.svg";